import { render, staticRenderFns } from "./pcConcMatProtocol.vue?vue&type=template&id=63158b85&scoped=true&slot=groupTitle&"
import script from "./pcConcMatProtocol.vue?vue&type=script&lang=js&"
export * from "./pcConcMatProtocol.vue?vue&type=script&lang=js&"
import style0 from "./pcConcMatProtocol.vue?vue&type=style&index=0&id=63158b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63158b85",
  null
  
)

export default component.exports